<template>
  <div>
    <a-spin :spinning="spinning" tip="Loading...">
      <!-- 加入overfloa-x参数使得在窗口变化的时候, 图不会突出去, 然后在刷新时候,echarts的自适应会消掉这个滑轨 -->
      <div id="myvolChart" :style="{ height: '500px' }"></div>
      <ul>
        <li>Cutoff: abs(log2FC) &gt;= 1, P-value &lt;= 0.05;</li>
        <li>
          <span style="color: red">{{ this.upregulated }} </span> Up-regulated
          genes VS
          <span style="color: blue">{{ this.downregulated }} </span>
          Down-regulated genes
        </li>
      </ul>
    </a-spin>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "hello",
  data() {
    return {
      umap: null,
      upregulated: 0,
      downregulated: 0,
      spinning: true,
    };
  },
  created() {
    axios
      .get("http://research.gzsys.org.cn/perturbdb/API/bulkseq/volcano.php", {
        params: {
          datasetId: this.$route.query.datasetID,
        },
      })
      .then((response) => {
        this.umap = response.data;
        this.drawLine(this.umap["data"]);
        this.upregulated = this.umap["up"];
        this.downregulated = this.umap["down"];
        this.spinning = false;
      });
  },
  methods: {
    drawLine(umap) {
      // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例
      let myChart = this.$echarts.init(document.getElementById("myvolChart"));
      // 绘制图表
      myChart.setOption({
        // title: { text: "Umap" },
        // width: 400,
        // height: 300,
        xAxis: {
          title: {
            text: "Log2Foldchange",
          },
        },
        yAxis: {
          title: {
            text: "-Log10(P-value)",
          },
        },
        //tooltips
        tooltip: {
          formatter: function (params) {
            var value = params.data;
            return (
              '<div style="font-size: 16px;padding-bottom: 7px;margin-bottom: 7px;"> Gene: ' +
              value[3] +
              "<br />  Avg_log2FC :" +
              value[0]
            );
          },
        },
        series: [
          {
            color: ["red", "blue"],
            data: umap,
            itemStyle: {
              color: function (params) {
                return params.data[2];
              },
            },
            type: "scatter",
            symbolSize: 3,
          },
        ],
      });
      //随着窗口的拖动,图自适应窗口的大小
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
  },
};
</script>
